import { useKeycloak } from "@/app/hook/use-keycloak";
import { useLoader } from "@/app/hook/use-loader";
import { useLocalization } from "@/app/hook/use-localization";
import { useProfile } from "@/app/hook/use-profile";
import { useShoppingCart } from "@/app/hook/use-shopping-cart";
import { useSystemView } from "@/app/hook/use-system-view";
import { useTemporaryService } from "@/services";
import { useEffect, useState } from "react";
import { useLocation, useNavigation, useSearchParams } from "react-router-dom";

export function usePageRootHook() {
  const systemView = useSystemView();
  const localization = useLocalization();
  const { setLoader } = useLoader();
  const { profile } = useProfile();
  const keycloak = useKeycloak();
  const temporary = useTemporaryService();
  const [isOpenModalMenu, setIsOpenModalMenu] = useState<boolean>();
  const navigation = useNavigation();
  const location = useLocation();
  const { total: shoppingCartTotal } = useShoppingCart();
  const [searchParams] = useSearchParams();
  const fetchCloseHeaderMenu = () => {
    setIsOpenModalMenu(false);
  };

  const fetchOpenHeaderMenu = () => {
    setIsOpenModalMenu(true);
  };

  useEffect(() => {
    if (navigation.state === "loading") {
      setLoader(true);
    }
  }, [navigation.state]);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [location]);

  useEffect(() => {
    if (searchParams.get("tgId")) {
      temporary.update({
        UserId: searchParams.get("tgId") || "",
        Token: keycloak.token || "",
        FirstName: profile?.FirstName || "",
        LastName: profile?.LastName || "",
      });
    }
  }, [profile, keycloak]);

  return {
    shoppingCartTotal,
    profile,
    keycloak,
    isOpenModalMenu,
    localization,
    systemView,
    fetchCloseHeaderMenu,
    fetchOpenHeaderMenu,
  };
}
